import { faUser } from "@fortawesome/free-solid-svg-icons";
import { isDefinedString } from "et3-type-guards";

import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCoreLoginStore from "../../stores/core/core-login-store";
import LoginTextField from "./LoginTextField";

const UsernameFormItem = withLiteObserverAndTheme(() => {
  const store = getCoreLoginStore();
  const disabledEnter = store.isSignInDisabled.get();
  const hasError = isDefinedString(i18n.get(store.errorKey.get()));

  return (
    <LoginTextField
      icon={faUser}
      type={"text"}
      label={i18n.get("USERNAME")}
      hint={i18n.get("LOGIN_USERNAME_HINT")}
      value={store.username.get()}
      hasError={hasError}
      onChoose={(value: string) => getCoreLoginStore().setUserName(value)}
      onEnter={() => {
        if (!disabledEnter) {
          getCoreLoginStore().signIn();
        }
      }}
    />
  );
});
export default UsernameFormItem;
